/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AreaBlacklistAddDto as OkEgisServiceModelsDtoAreaBlacklistAddDto } from '../models/OK/Egis/Service/Models/DTO/area-blacklist-add-dto';
import { AreaBlacklistDto as OkEgisServiceModelsDtoAreaBlacklistDto } from '../models/OK/Egis/Service/Models/DTO/area-blacklist-dto';

@Injectable({
  providedIn: 'root',
})
export class AreaBlacklistService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllAreaBlacklist
   */
  static readonly GetAllAreaBlacklistPath = '/api/v1/AreaBlacklist/GetAllAreaBlacklist';

  /**
   * Returns a list of area blacklisted.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAreaBlacklist()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAreaBlacklist$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoAreaBlacklistDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AreaBlacklistService.GetAllAreaBlacklistPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoAreaBlacklistDto>>;
      })
    );
  }

  /**
   * Returns a list of area blacklisted.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllAreaBlacklist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAreaBlacklist(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoAreaBlacklistDto>> {

    return this.getAllAreaBlacklist$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoAreaBlacklistDto>>) => r.body as Array<OkEgisServiceModelsDtoAreaBlacklistDto>)
    );
  }

  /**
   * Path part for operation addAreaBlacklist
   */
  static readonly AddAreaBlacklistPath = '/api/v1/AreaBlacklist/AddAreaBlacklist';

  /**
   * Adds an area to the blacklist.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addAreaBlacklist()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAreaBlacklist$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoAreaBlacklistAddDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoAreaBlacklistDto>> {

    const rb = new RequestBuilder(this.rootUrl, AreaBlacklistService.AddAreaBlacklistPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoAreaBlacklistDto>;
      })
    );
  }

  /**
   * Adds an area to the blacklist.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addAreaBlacklist$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAreaBlacklist(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoAreaBlacklistAddDto
  }): Observable<OkEgisServiceModelsDtoAreaBlacklistDto> {

    return this.addAreaBlacklist$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoAreaBlacklistDto>) => r.body as OkEgisServiceModelsDtoAreaBlacklistDto)
    );
  }

  /**
   * Path part for operation removeAreaBlacklist
   */
  static readonly RemoveAreaBlacklistPath = '/api/v1/AreaBlacklist/RemoveAreaBlacklist';

  /**
   * Deletes an area form the blacklist.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeAreaBlacklist()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeAreaBlacklist$Response(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AreaBlacklistService.RemoveAreaBlacklistPath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deletes an area form the blacklist.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeAreaBlacklist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeAreaBlacklist(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.removeAreaBlacklist$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
